<div
  *ngIf='componentReady'
  [formGroup]='inputForm'
  class='EditUserDetailsDialog container'>
  <div class='row'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Email</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='email' placeholder='Email' type='email'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>First Name</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='first_name'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Last Name</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='last_name' placeholder='Last Name'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Address 1</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='address1' placeholder='Address 1'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Address 2</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='address2' placeholder='Address 2'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>City</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='city' placeholder='City'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Zip code</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='zip' placeholder='Zip' type='zip'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-3 d-flex align-items-center'>
      <mat-label>Phone number</mat-label>
    </div>
    <div class='col col-9'>
      <app-text-field formControlName='phone_number' placeholder='Phone number'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-9 offset-3'>
      <div class='form-group'>
        <app-select
          [items]='states'
          formControlName='state'
          label='State'></app-select>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-9 offset-3'>
      <div class='form-group'>
        <app-select
          (selection)='onCountrySelect($event)'
          [items]='countries'
          formControlName='country'
          label='Country'></app-select>
      </div>
    </div>
  </div>
</div>
